/**
 * Review Response Settings module
 * Based largely on the Social Approval Settings module
 */
goog.provide('yext.social.reviewresponse.settings');

goog.require('yext');
goog.require('yext.Field');
/** @suppress {extraRequire} */
goog.require('yext.plugins.ajaxChosen');

goog.scope(function() {
  var _settings = yext.social.reviewresponse.settings;

  _settings.init = function() {
    _settings.$row = $('.js-reviewresponse-settings');
    _settings.$displayMode = _settings.$row.find('.js-display-mode');

    _settings.field = new yext.Field(_settings.$row.find('.js-reviewresponse-form'));

    _settings.storedValues = _settings.getReviewResponseSettings();

    _settings.bindToggleEdit();
    _settings.bindToggleEnabled();
    _settings.bindUserSelect();
    _settings.bindSubmit();
  };

  goog.exportSymbol('yext.social.reviewresponse.settings.init', _settings.init);

  /**
   * Get current review response settings
   */
  _settings.getReviewResponseSettings = function() {
    return {
      enabled: getReviewResponseEnabled(),
      notifyApprovers: getNotifyApprovers(),
      notifySubmitters: getNotifySubmitters(),
      approvers: _settings.getApproverDetails(),
    };
  };

  _settings.getApproverDetails = function() {
    return _settings.$row.find('.js-user-select option:selected').map(function() {
      var $this = $(this);
      return {
        label: $this.text(),
        value: $this.val(),
      };
    }).get();
  };

  /**
   * Toggle edit
   */
  _settings.bindToggleEdit = function() {
    _settings.$row.click(function() {
      if (!_settings.$row.hasClass('toggles-row-edit')) {
        _settings.toggleEdit(true);
      }
    });

    _settings.$row.find('.js-cancel').click(function(e) {
      e.stopPropagation();
      _settings.toggleEdit(false);
      _settings.reset();
    });
  };

  _settings.bindToggleEnabled = function() {
    _settings.field.$form.change(function() {
      _settings.field.enableSubmit();
      _settings.$row.find('.js-more-reviewresponse-settings').toggle(getReviewResponseEnabled());
    });
  };

  _settings.bindUserSelect = function() {
    _settings.$row.find('.js-user-select').ajaxChosen({
      url: '/s/' + yext.businessId + '/user/getReviewResponseApprovers',
    }, function(data) {
      var terms = {};
      for (var i = 0; i < data.length; i++) {
        terms[data[i].id] = sanitizeInput(data[i].label);
      }
      return terms;
    });
  };

  _settings.toggleEdit = function(show) {
    _settings.$row.toggleClass('toggles-row-edit', show);
    _settings.$displayMode.toggle(!show);
    _settings.field.$form.toggle(show);

    if (!show) {
      _settings.field.disableSubmit();
    }
  };

  _settings.bindSubmit = function() {
    _settings.field.$form.on('beforeSubmit.field', function() {
      _settings.field.disableSubmit();
      if (!getReviewResponseEnabled()) {
        toggleFieldsEnabled(false);
      }
    });

    _settings.field.$form.on('save.field', function(e, response) {
      if (response.error) {
        _settings.$row.find('.js-error').html(response.error.message).show();
      } else {
        _settings.$row.find('.js-error').hide();
        _settings.storedValues = _settings.getReviewResponseSettings();
        _settings.renderDisplayMode();
        _settings.toggleEdit(false);
        toggleFieldsEnabled(true);
      }
    });
  };

  _settings.renderDisplayMode = function() {
    _settings.$displayMode
      .find('.js-display-enabled')
      .text(_settings.storedValues.enabled ? 'On' : 'Off');
    _settings.$displayMode
      .find('.js-display-submitters')
      .toggle(_settings.storedValues.enabled && _settings.storedValues.notifySubmitters);
    _settings.$displayMode
      .find('.js-display-approvers')
      .toggle(_settings.storedValues.enabled && _settings.storedValues.notifyApprovers)
      .find('.js-display-approver-count')
      .text(yext.msgn('1 Approver', '{0} Approvers', _settings.storedValues.approvers.length));
  };

  _settings.reset = function() {
    _settings.$row.find('.js-reviewresponse-enabled[value=true]').prop('checked', _settings.storedValues.enabled);
    _settings.$row.find('.js-reviewresponse-enabled[value=false]').prop('checked', !_settings.storedValues.enabled);
    _settings.$row.find('.js-more-reviewresponse-settings').toggle(_settings.storedValues.enabled);
    _settings.$row.find('.js-notify-approvers').prop('checked', _settings.storedValues.notifyApprovers);
    _settings.$row.find('.js-notify-submitters').prop('checked', _settings.storedValues.notifySubmitters);

    // Restore chosen multiselect
    var $userSelect = _settings.$row.find('.js-user-select').empty();
    for (var i = 0; i < _settings.storedValues.approvers.length; i++) {
      $userSelect.append($('<option/>', {
        text: _settings.storedValues.approvers[i].label,
        value: _settings.storedValues.approvers[i].value,
        selected: true,
      }));
    }
    $userSelect.trigger('chosen:updated');
  };

  /**
   * Determines if review response is enabled or not.
   */
  var getReviewResponseEnabled = function() {
    return _settings.$row.find('.js-reviewresponse-enabled[value=true]').prop('checked');
  };

  /**
   * Determines if the "Notify Approvers" option is checked.
   */
  var getNotifyApprovers = function() {
    return _settings.$row.find('.js-notify-approvers').prop('checked');
  };

  /**
   * Determines if the "Notify Submitters" option is checked.
   */
  var getNotifySubmitters = function() {
    return _settings.$row.find('.js-notify-submitters').prop('checked');
  };

  var toggleFieldsEnabled = function(enable) {
    _settings.$row.find('.js-notify-approvers, .js-notify-submitters, .js-user-select').prop('disabled', !enable);
  };

  const sanitizeInput = function(text) {
    const div = document.createElement('div');
    div.innerText = text;
    return div.innerHTML;
  };
});
